import type { FC } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { formatDate, formatTime } from 'app/utils/date';
import BlockTemplate from 'app/components/Blocks/BlockTemplate';
import ConfigContext from 'app/common/ConfigContext';
import TeamName from 'app/components/TeamName';
import VideogameVersionTag from 'app/components/VideogameVersionTag';

import style from './style.module.scss';

interface Props {
  data: NameBlockMatch;
}

const MatchTitle: FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const { lang } = useContext(ConfigContext);

  const date = data.begin_at && new Date(data.begin_at);

  return (
    <BlockTemplate
      opponentsLogo={[data.opponents.at(0), data.opponents.at(1)]}
      containerClassname={style.matchTitleBlockContent}
      className="override-block_name"
    >
      <h1 className={style.serieName}>
        {data.league_name} {data.serie_full_name} {data.tournament_name}{' '}
        <VideogameVersionTag name={data.videogame_title} />
      </h1>
      <TeamName.Container className={style.teamsNames}>
        <TeamName
          team={data.opponents.at(0)}
          logoStyle={style.teamNameSideLogo}
          className={style.teamNameSide}
        />
        <TeamName
          team={data.opponents.at(0)}
          logoStyle={style.teamNameBottomStyle}
          namePosition="bottom"
          className={style.teamNameBottom}
        />
        <div className={style.vs}>{t('all-versus')}</div>
        <div className={style.fullDateTime}>
          {date && (
            <>
              <div className={style.fullTime}>{formatTime(date, lang)}</div>
              <div className={style.fullDate}>{formatDate(date, lang, { month: 'short' })}</div>
            </>
          )}
        </div>
        <TeamName
          team={data.opponents.at(1)}
          logoStyle={style.teamNameSideLogo}
          className={style.teamNameSide}
          orientation="reversed"
        />
        <TeamName
          team={data.opponents.at(1)}
          logoStyle={style.teamNameBottomStyle}
          namePosition="bottom"
          className={style.teamNameBottom}
          orientation="reversed"
        />
      </TeamName.Container>
      {date && (
        <div className={style.date}>
          {formatDate(date, lang, { day: '2-digit', month: '2-digit' })}
        </div>
      )}
    </BlockTemplate>
  );
};

MatchTitle.displayName = 'MatchTitle';

export default MatchTitle;
